import styled from 'styled-components';
import { colorMap, colors } from '../../globalStyles';
import { HELVETICA } from '../../globalStyles/text';
import { Link } from '../Links';

export const HeadCell = styled.div`
  font-family: ${HELVETICA};
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  background-color: ${colorMap.background[0]};
  color: ${colors.grayText};
  font-weight: bold;
  font-size: 0.875rem;
  box-shadow: none;
  border-bottom: 1px solid ${colors.grey.widgetBorder};
  user-select: none;
`;

export const BodyCell = styled.div<{ $disabled?: boolean }>`
  padding: 0.5rem 1rem;
  border-top: 1px solid #f0f1f3;
  color: ${colors.text};
  box-sizing: border-box;
  height: 100%;
  min-height: 4rem;
  display: flex;
  align-items: center;
  ${({ onClick }) => (onClick ? 'cursor: pointer;' : '')}
  ${({ $disabled }) => ($disabled ? 'opacity: 0.7;' : '')}
`;

export const LinkCell = styled(Link)`
  cursor: pointer;
  padding: 0;
  background: none;
  outline: none;
  color: inherit;
  text-decoration: unset;
`;

/**
 * The toolbar a list composes above its `DataTable`: a responsive grid of controls (selects,
 * toggles) — two per row, three from 1110px, four from 1400px.
 */
export const TableToolbar = styled.div`
  display: grid;
  gap: 1rem 1.5rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 1rem;

  @media (min-width: 1110px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const TableSearch = styled.div<{ fullWidth?: boolean }>`
  margin-right: 1em;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '200px')};
  margin-bottom: 1em;
`;
